"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _callIfFunc = _interopRequireDefault(require("../call-if-func"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Hook for focus/blur event handlers with optional target to provide DOM node
 * @param {Function} [onBlur] Additionally called with event when `handleBlur` is invoked
 * @param {Function} [onFocus] Additionally called with event when `handleFocus` is invoked
 * @param {boolean} [options.lock] Whether to keep current focus state
 * @param {Element} [options.target] References the DOM node to determine blur state
 * @returns {[boolean, handleBlur, handleFocus]} [hasFocus, `handleBlur`, `handleFocus`]
 */
var useFocus = function useFocus(initialValue, onBlur, onFocus, _temp) {
  if (initialValue === void 0) {
    initialValue = false;
  }

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$lock = _ref.lock,
      lock = _ref$lock === void 0 ? false : _ref$lock,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? null : _ref$target;

  var _useState = (0, _react.useState)(initialValue),
      hasFocus = _useState[0],
      setHasFocus = _useState[1];
  /** Checks to see if event contains ref target and either keeps/removes focus */


  var handleBlur = (0, _react.useCallback)(function (e) {
    if (!lock) {
      setHasFocus(target && target.contains(e.relatedTarget));
    }

    (0, _callIfFunc["default"])(onBlur, e);
  }, [lock, onBlur, target]);
  /** Sets focus to true and invokes `onFocus` callback */

  var handleFocus = (0, _react.useCallback)(function (e) {
    if (!lock) {
      setHasFocus(true);
    }

    (0, _callIfFunc["default"])(onFocus, e);
  }, [lock, onFocus]);
  return [hasFocus, handleBlur, handleFocus];
};

var _default = useFocus;
exports["default"] = _default;